import SubMenu from './src/SubMenu.vue'

SubMenu.install = function(Vue) {
    Vue.component(SubMenu.name, SubMenu)
}

export default SubMenu